'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */

import React from 'react';
import { FeLink } from '../../../components/FeLink';
import { PushDataLayerFn } from '../../../types/pushDataLayer';
import { useCmsClientContext } from '../../../utils/cmsPageContext';
import { CmsNavigation } from '../types';
import { navbarLinkToUrl } from '../utils/utils';
import LinkGroup from './LinkGroup';

/** The `index` a top-level header item sends: `2.0.0` for the third. */
export const topLevelIndex = (position: number) => `${position}.0.0`;

interface DropdownMenuProps {
  dropdownMenu?: CmsNavigation;
  pushDataLayer: PushDataLayerFn;
}

const DropdownMenu: React.FC<DropdownMenuProps> = (props) => {
  const { dropdownMenu, pushDataLayer } = props;
  const { brand, langPrefix } = useCmsClientContext();

  const handleInteraction = (event: string, label: string, index: string) => {
    pushDataLayer({
      event: 'navigate',
      component_type: 'top-nav',
      component_title: `Level 1_${label}`,
      action: event,
      index,
    });
  };

  if (!dropdownMenu) {
    return null;
  }

  return (
    <div className="z-30 hidden items-center lg:flex" data-header-item="dropdown">
      {dropdownMenu!.items!.map((menuItem, index) => {
        const { text, href, url_target } = navbarLinkToUrl(menuItem!, {
          brand,
          langPrefix,
        });
        return (
          <div key={`${text}_${href}`} className="group flex">
            <FeLink
              href={href}
              target={url_target}
              className="h-full border-b-4 border-transparent px-4 py-[22px] font-bold text-[#687076] text-[16px] hover:border-b-4 hover:border-[#0080F0] hover:text-[#212529] lg:px-3 xl:px-4"
              // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
              onClick={(e) => {
                e.stopPropagation();
                handleInteraction('click', text, topLevelIndex(index));
              }}
              // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
              onMouseOver={() =>
                handleInteraction('hover', text, topLevelIndex(index))
              }
            >
              {text}
            </FeLink>
            {menuItem?.sublinks && menuItem?.sublinks.length > 0 && (
              <div className="absolute left-0 top-18 hidden w-full px-3 py-12 transition-all duration-1000 bg-[#F1F3F5] group-hover:block">
                <div
                  // eslint-disable-next-line tailwindcss/no-custom-classname -- replace material-tailwind class
                  className="divide mx-auto grid max-w-[65rem] grid-cols-4 gap-6 divide-x divide-[#D7DBDF]"
                >
                  {menuItem?.sublinks.map((sublink, index_level_2) => {
                    const sublinkUrl = navbarLinkToUrl(sublink!, {
                      brand,
                      langPrefix,
                    });
                    if (!sublinkUrl.href) {
                      return null;
                    }
                    return (
                      <LinkGroup
                        key={`${sublinkUrl.text}_${sublinkUrl.href}`}
                        index_level_one={`${index}.${index_level_2}`}
                        pushDataLayer={pushDataLayer}
                        {...sublink!}
                      />
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DropdownMenu;
